import React, { useEffect, useState } from "react";
import "./index.scss";

import { useNavigate, useParams } from "react-router-dom";

import UserService from "../../../services/user-auth/user.service";
import { showErrorToaster } from "../../../components/toaster/error";
import { showSuccessToaster } from "../../../components/toaster/success";
const userService = new UserService();

const UserEditForm = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    image: "",
    oldPassword: "",
    password: "",
  });
  const [imagePreview, setImagePreview] = useState(null); // Pour l'aperçu de l'image
  const [error, setError] = useState("");
  const [data, setJobList] = useState([]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  useEffect(() => {
    if (id) {
      // Si un identifiant est présent, nous sommes en mode "édition"
      const fetchMissionData = async () => {
        try {
          const response = await userService.getUserById(id);
          setFormData(response.data); // Remplit le formulaire avec les données existantes
        } catch (error) {
          showErrorToaster(
            error.response
              ? error.response.data.message
              : "Erreur lors du chargement des données."
          );
        }
      };
      fetchMissionData();
    }
  }, [id]);
  const handleImageChange = (e) => {
    const file = e.target.files[0]; // Récupère le fichier sélectionné
    if (file) {
      setFormData((prevData) => ({
        ...prevData,
        image: file, // Met à jour l'image dans l'état
      }));
      setImagePreview(URL.createObjectURL(file)); // Met à jour l'aperçu de l'image
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setJobList([...data, formData]);

    if (
      !formData.name ||
      !formData.email ||
      !formData.oldPassword ||
      !formData.password
    ) {
      setError("Veuillez remplir tous les champs.");
      return;
    }

    try {
      const formDataToSend = new FormData();
      formDataToSend.append("name", formData.name);
      formDataToSend.append("email", formData.email);

      formDataToSend.append("image", formData.image);
      formDataToSend.append("password", formData.password);
      formDataToSend.append("oldPassword", formData.oldPassword);
      // Sinon, on crée une nouvelle réalisation
      await userService.editUsers(id, formDataToSend);

      showSuccessToaster("Création réussie.");

      navigate("/user-liste");
    } catch (error) {
      showErrorToaster(
        error.response
          ? error.response.data.message
          : "Une erreur est survenue, veuillez réessayer."
      );
    }
  };

  return (
    <div className="job-form-container">
      <h1> Edit un utilisateur </h1>
      <form onSubmit={handleSubmit}>
        {error && <div className="error-message">{error}</div>}
        <div className="form-group">
          <label>Nom et prénom :</label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label>Email:</label>
          <input
            type="text"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label>Ancien mot de passe:</label>
          <input
            type="text"
            name="oldPassword"
            value={formData.oldPassword}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label>Mot de passe:</label>
          <input
            type="text"
            name="password"
            value={formData.password}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label>Image:</label>
          <input
            type="file"
            name="image"
            accept="image/*"
            onChange={handleImageChange}
          />

          <p>
            {formData?.image
              ? formData?.image?.name
                ? formData?.image?.name
                : formData?.image
              : "Aucune image sélectionnée"}
          </p>
        </div>
        <button type="submit" className="submit-button">
          Créer
        </button>
      </form>
    </div>
  );
};

export default UserEditForm;
